import { useEffect, useRef } from "react";

const PhoneBuyBackSimulationQuestions = ({ questions, onQuestionAnswer }) => {
  const questionRef = useRef();

  useEffect(() => {
    if (questionRef?.current) {
      questionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [questions]);

  return (
    <>
      {questions.map((question) => (
        <li key={question.question_id} ref={questionRef}>
          <div className="text-[14px] font-medium mb-[10px]">
            {question?.question_text}
          </div>

          <div className="flex gap-[10px]">
            <button
              type="button"
              onClick={() =>
                onQuestionAnswer({
                  question: {
                    ...question,
                    answer: question.options[0].option,
                    grade: question.options[0].grade.toUpperCase(),
                  },
                })
              }
              className={`border border-[#ccc] hover:border-[#F5CB38] ${
                question.answer === question.options[0].option
                  ? "border-[#F5CB38]"
                  : ""
              } w-full py-[12px] rounded-bl-[4px]`}
            >
              {question.options[0].option}
            </button>

            <button
              type="button"
              onClick={() =>
                onQuestionAnswer({
                  question: {
                    ...question,
                    answer: question.options[1].option,
                    grade: question.options[1].grade.toUpperCase(),
                  },
                })
              }
              className={`border border-[#ccc] hover:border-[#F5CB38] ${
                question.answer === question.options[1].option
                  ? "border-[#F5CB38]"
                  : ""
              } w-full py-[12px] rounded-tr-[4px]`}
            >
              {question.options[1].option}
            </button>
          </div>
        </li>
      ))}
    </>
  );
};

export default PhoneBuyBackSimulationQuestions;
